import React, { useState } from "react";
import "./styles.scss";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import { CircularProgressWithLabel } from "../ProgressBar";
import { Paper } from "@mui/material";

const FileUpload = ({
  acceptFileType = "image/*",
  handleChange,
  label,
  bgImageSrc,
  upProgress,
  className,
  ...otherProps
}) => {
  const isUploading = upProgress !== 100 && upProgress !== 0;
  const [isDragging, setIsDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isUploading) setIsDragging(true);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isUploading) setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (isUploading) return;

    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleChange({
        target: {
          files: e.dataTransfer.files,
        },
      });
    }
  };

  return (
    <label
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className={
        (isUploading ? "custom-file-upload uploading" : "custom-file-upload") +
        (isDragging ? " drag-over" : "") +
        (className ? ` ${className}` : "")
      }
    >
      {!isUploading && (
        <input type="file" onChange={handleChange} accept={acceptFileType} />
      )}
      <Paper
        style={{
          backgroundImage: String(acceptFileType).includes("image")
            ? `url(${bgImageSrc})`
            : "",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100%",
          width: "100%",
          position: "relative",
        }}
      >
        {isUploading && <CircularProgressWithLabel value={upProgress} />}
        {!isUploading && (
          <>
            {String(acceptFileType).includes("video") && (
              <VideoLibraryOutlinedIcon className="bg-video-icon" />
            )}
            <AddCircleOutlineIcon className="add-icon placeholder" />
            {label && <div className="upload-label">{label}</div>}
          </>
        )}
      </Paper>
    </label>
    // </div>
  );
};

export default FileUpload;
